import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.scss"
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Pinverify from './Components/pinverify';
import Home from './App';
import TokenVerify from './Components/tokenVerify';
import MoneyCode from './Components/moneycodes';
import CoderCheker from './Components/coderCheker';
import FleetPage from './Components/newBoard';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route Component={Pinverify} path='/:pins'></Route>
        <Route Component={FleetPage} path='/login'></Route>
        <Route Component={Pinverify} path='/pinverify'></Route>
        <Route Component={TokenVerify} path='/tokenverify'></Route>
      </Routes>
    </Router>
  </React.StrictMode>
);


